export default {
  statementApi: {
    totalMonthReport: 'api/statementSysMonthReportApi/totalMonthReport',
    exportTotalReport: 'api/statementSysMonthReportApi/exportTotalReport',

    generateReport: 'api/statementApi/generateReport',
    exportReport: 'api/statementApi/exportData',
    // 月报列表
    monthReport: 'api/statementReportApi/monthReport',
    // 生成月报
    generateMonthReport: 'api/statementReportApi/generateMonthReport',
    resetMonthReport: 'api/statementReportApi/resetMonthReport',
    // 月报详情
    monthReportDetail: 'api/statementReportApi/monthReportDetail',
    // 编辑月报
    updateMonthReport: 'api/statementReportApi/updateMonthReport',
    //删除月报
    delMonthReport: 'api/statementReportApi/delMonthReport',
    // 下发月报
    issueMonthReport: 'api/statementReportApi/issueMonthReport',
    issueBatchMonthReport: 'api/statementReportApi/issueBatchMonthReport',
    // 审核月结单
    auditMonthReport: 'api/statementReportApi/auditMonthReport',
    // 撤回月报
    revokeMonthReport: 'api/statementReportApi/revokeMonthReport',
    // 最新的退回记录
    nearlyRejectLog: 'api/statementReportApi/nearlyRejectLog',
  },
  confirmStatementReportApi: {
    confirmationMonthReportList: 'api/confirmStatementReportApi/confirmationMonthReportList',
    // 退回报表
    rejectMonthReport: 'api/confirmStatementReportApi/rejectMonthReport',
    // 确认报表
    confirmedMonthReport: 'api/confirmStatementReportApi/confirmedMonthReport',
    // 上传发票
    submitInvoice: 'api/confirmStatementReportApi/submitInvoice',
    // 确认收款
    confirmReceived: 'api/confirmStatementReportApi/confirmReceived',
    checkDays: 'api/confirmStatementReportApi/checkDays'
  }
}